import { Banner } from 'hfs-common-ui';
import { MaintenanceEnum } from 'core/models/maintenance.model';
import { useTranslationWrapper } from 'core/hooks/use-translation-wrapper';
import { InternationalizationBackendNameSpace } from 'core/models/internationalization-namespace';
import { Application } from 'core/models/common.model';
import useMaintenanceBanner from 'core/hooks/use-maintenance-banner';
import * as S from './styled';

interface Props {
  statusMode: MaintenanceEnum;
}

const MaintenanceBanner = ({ statusMode }: Props) => {
  const { t } = useTranslationWrapper(InternationalizationBackendNameSpace.IncidentCommunication);
  const { shouldRender, showBanner, bannerRef, appStatusConfig, setIsVisible } = useMaintenanceBanner({
    statusMode,
  });

  if (!shouldRender) {
    return null;
  }

  return (
    <S.FixedBannerDiv $visible={showBanner} ref={bannerRef}>
      <Banner
        bannerMessage={t(`incidentCommunication.banner.${appStatusConfig.bannerMessage}.message`, {
          name: Application.Fleet,
        })}
        bannerSeverity={appStatusConfig.bannerSeverity as 'WARNING' | 'INFO'}
        icon={appStatusConfig.bannerSeverity === 'WARNING' ? 'notification.warning' : 'notification.info_outlined'}
        onClose={() => setIsVisible(false)}
      />
    </S.FixedBannerDiv>
  );
};

export default MaintenanceBanner;
